// extracted by mini-css-extract-plugin
export default {"search_cover":"SearchCover_search_cover__-xiiR","hide":"SearchCover_hide__Vs7AP","focus":"SearchCover_focus__htLhu"};